import { ITransactionFilters, ITransactionEffectiveDate, ITransactionLineItem, IClaim, IClaimTask, IResidentTransactionsLineItemsFilters } from '@zunta/configurations'
import { IBaseStore } from '../types'
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import Api from '../../api'

export interface ITransactionsState {
  transactions: ITransactionEffectiveDate[],
  totalTransactions: number,
  transactionLineItems: ITransactionLineItem[],
  transactionIntervals: number[],
  aging: any
  agingDetails: any
}

export interface ITransactionsStore extends IBaseStore {
  state: ITransactionsState
}

@Module({
  name: 'transactions',
  namespaced: true
})
export class TransactionsModule extends VuexModule {
  transactions: ITransactionEffectiveDate[] = [];
  totalTransactions: number = 0;
  transactionLineItems: ITransactionLineItem[] = []
  transactionResidentLineItems: ITransactionLineItem[] = []
  totalTransactionResidentLineItems: number = 0;
  transactionIntervals: number[] = []
  aging: any = {}
  agingDetails: any = {};

  @Mutation
  SET_TRANSACTION_LINE_ITEMS (lineItems: ITransactionLineItem[]) {
    this.transactionLineItems = lineItems
  }

  @Mutation
  SET_TRANSACTION_INTERVAL_VALUE (intervals: number[]) {
    this.transactionIntervals = intervals
  }

  @Mutation
  SET_TRANSACTIONS_LIST (transactions: ITransactionEffectiveDate[]) {
    this.transactions = transactions
  }

  @Mutation
  SET_RESIDENT_TRANSACTION_LINE_ITEMS (transactions: ITransactionLineItem[]) {
    this.transactionResidentLineItems = transactions
  }

  @Mutation
  SET_RESIDENT_TRANSACTION_LINE_ITEMS_TOTAL (total: number) {
    this.totalTransactionResidentLineItems = total
  }

  @Mutation
  SET_TRANSACTIONS_TOTAL (total: number) {
    this.totalTransactions = total
  }

  @Mutation
  SET_AGING (total: number) {
    this.aging = total
  }

  @Mutation
  SET_AGING_DETAILS (details: { claim: IClaim[], tasks: IClaimTask[] }) {
    this.agingDetails = details
  }

  @Action
  async getResidentTransactions (input: { residentId: number | string, filters: ITransactionFilters }) {
    const { total, transactions } = await Api.transactions.getResidentTransactions(input.residentId, input.filters)
    this.SET_TRANSACTIONS_LIST(transactions)
    this.SET_TRANSACTIONS_TOTAL(total)
  }

  @Action
  async getResidentTransactionLineItems (input: { residentId: number | string, filters: IResidentTransactionsLineItemsFilters }) {
    const { total, transactions } = await Api.transactions.getResidentTransactionLineItems(input.residentId, input.filters)
    this.SET_RESIDENT_TRANSACTION_LINE_ITEMS(transactions)
    this.SET_RESIDENT_TRANSACTION_LINE_ITEMS_TOTAL(total)
  }

  @Action
  async getTransactionLineItems (transactionId: number) {
    const transactionLineItems = await Api.transactions.getTransactionLineItems(transactionId)
    this.SET_TRANSACTION_LINE_ITEMS(transactionLineItems)
  }

  @Action
  async getGroupedPaymentsTotals (residentId: number | string) {
    const res = await Api.transactions.getGroupedPaymentsTotals(residentId)
    this.SET_TRANSACTION_INTERVAL_VALUE(res)
  }

  @Action
  async getAging (residentId: number | string) {
    const res = await Api.transactions.getAging(residentId)
    this.SET_AGING(res)
  }

  @Action 
  async getAgingDetails (transactionId: number | string) {
    const res = await Api.transactions.getAgingDetails(transactionId)
    this.SET_AGING_DETAILS(res)
  }
}
